<template>
  <div class="row">
    <div class="col-md-4 form-group">
      <label>Tipo</label>
      <select
        v-model="value.object_type"
        class="form-control"
        :disabled="disabled"
      >
        <option value="">
          Selecione
        </option>
        <option value="arma">
          Arma
        </option>
        <option value="eletronico">
          Eletrônico
        </option>
        <option value="documento">
          Documento
        </option>
        <option value="joia">
          Joia/Valor
        </option>
        <option value="outro">
          Outro
        </option>
      </select>
    </div>
    <div class="col-md-8 form-group">
      <label><span class="text-danger">*</span> Descrição</label>
      <input
        v-model="value.description"
        type="text"
        class="form-control"
        :class="{ 'is-invalid': errors.description }"
        :disabled="disabled"
        placeholder="Ex: notebook Dell preto"
      >
      <div
        v-if="errors.description"
        class="invalid-feedback"
      >
        Campo obrigatório.
      </div>
    </div>

    <div class="col-md-5 form-group">
      <label>Marca</label>
      <input
        v-model="value.brand"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>
    <div class="col-md-4 form-group">
      <label>Modelo</label>
      <input
        v-model="value.model"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>
    <div class="col-md-3 form-group">
      <label>Quantidade</label>
      <input
        v-model.number="value.quantity"
        type="number"
        min="1"
        class="form-control"
        :disabled="disabled"
      >
    </div>

    <div class="col-md-6 form-group">
      <label>Nº de série</label>
      <input
        v-model="value.serial_number"
        type="text"
        class="form-control"
        :disabled="disabled"
      >
    </div>
    <div class="col-md-6 form-group">
      <label>Valor estimado (R$)</label>
      <input
        v-model.number="value.estimated_value"
        type="number"
        step="0.01"
        min="0"
        class="form-control"
        :disabled="disabled"
      >
    </div>

    <div class="col-12 form-group">
      <label>Observação</label>
      <textarea
        v-model="value.observation"
        class="form-control"
        rows="2"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedObjectForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
